/*
 * The browser tab's title per route (TDI-831 part 3, ruling R-050): every
 * page of the SEND and Neurodiversity Digital Hub — family, school, teacher,
 * shared, not-found and the staff side too — names the service, not the
 * company. The older pages being retired for school staff (/rms/sign-in,
 * /rms/dashboard, /rms/referral/...) and everything outside /rms keep the
 * app-wide default, so moving away from the hub puts it back.
 */

export const HUB_TAB_TITLE = 'SEND and Neurodiversity Digital Hub';
export const DEFAULT_TAB_TITLE = 'ThinkDivergent';

// The profile print page titles itself "{child's full name} strengths and
// needs profile" (TDI-827) so "Save as PDF" suggests that file name: this
// helper must not set or overwrite it.
const LEAVE_ALONE = [/^\/rms\/patient\/[^/]+\/hfp\/print(\/|$)/];

const LEGACY = [/^\/rms\/sign-in$/, /^\/rms\/dashboard$/, /^\/rms\/referral(\/|$)/];

/**
 * The title the tab should carry on this path: the hub's name on its pages,
 * the default everywhere else, or null for a page that titles itself.
 */
export function tabTitleFor(pathname) {
  const path = String(pathname || '');
  if (!path.startsWith('/rms')) return DEFAULT_TAB_TITLE;
  if (LEAVE_ALONE.some((re) => re.test(path))) return null;
  if (LEGACY.some((re) => re.test(path))) return DEFAULT_TAB_TITLE;
  return HUB_TAB_TITLE;
}
